// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Caixa_FecharResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for fechar() — POST /caixa/fechar/:id
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Caixa_FecharResponseDados {
success?: boolean
error?: string
diferenca?: number
saldo_final_esperado?: number
saldo_final_declarado?: number
status?: string
data_hora_fechamento?: string
}

export type Caixa_FecharResponse = ApiResponse<Caixa_FecharResponseDados>;

registerResponseContract('Caixa_FecharResponse', {
  success:               { type: 'boolean', required: false },
  error:                 { type: 'string',  required: false },
  diferenca:             { type: 'number',  required: false },
  saldo_final_esperado:  { type: 'number',  required: false },
  saldo_final_declarado: { type: 'number',  required: false },
  status:                { type: 'string',  required: false },
  data_hora_fechamento:  { type: 'string',  required: false },
})
